<template>
    <div class="sub-head">
        <div class="sub-visual">
            <v-container>
                <h2 class="sub-visual__tit">{{ sh }}</h2>
            </v-container>
            <div class="sub-visual__bg" :style="'background-image:url(' + bg + ');'"></div>
        </div>
        <client-gnb v-if="tabActive" className="sub-tab-wrap" :tabActive="tabActive" :sh="sh"></client-gnb>
    </div>
</template>

<script>
import ClientGnb from "@/components/client/ko/inc/client-gnb.vue";

export default {
    props: {
        sh: { type: String, default: "" },
        bg: { type: String, default: "" },
        tabActive: { type: String, default: "" },
    },
    components: {
        ClientGnb,
    },
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            setTimeout(() => {
                AOS.init({
                    once: false,
                    offset: 240,
                    duration: 500,
                    throttleDelay: 100,
                    easing: "ease-in-out",
                    anchorPlacement: "top-center",
                });
            }, 100);
        },
    },
};
</script>

<style scoped>
/* sub-visual */
.sub-visual {
    position:relative;
    display: flex;
    align-items: center;
    text-align: center;
    height: 200px;
    padding-top: calc(var(--header-body) /2);
}
.sub-visual__tit {
    font-size: 3rem;
    font-weight:700;
    color:#fff;
}
.sub-visual__bg {
    position: absolute;
    top:0;
    left: 50%;
    z-index: -1;
    -webkit-transform: translate(-50%,0); -ms-transform: translate(-50%,0); transform: translate(-50%,0);
    width: 100vw;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 300px;
        padding-top:0;
    }
    .sub-visual__tit {
        font-size: 4rem;
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 500px;
        padding-top: 0;
    }
    .sub-visual__tit {
        font-size: 6.4rem;
    }
}
@media (min-width: 1200px) {
}
</style>
